import type { GlobalThemeOverrides } from 'naive-ui'

/**
 * Naive UI theme overrides for Garden / Almanac direction.
 * Values align with libs/design-tokens/garden.css
 */
export const gardenThemeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#4d6349',
    primaryColorHover: '#405239',
    primaryColorPressed: '#354430',
    primaryColorSuppl: '#e6ece2',

    bodyColor: '#f0eee8',
    cardColor: '#ffffff',
    modalColor: '#ffffff',
    popoverColor: '#ffffff',

    textColorBase: '#2a3328',
    textColor1: '#14201a',
    textColor2: '#2a3328',
    textColor3: 'rgba(42, 51, 40, 0.72)',

    borderColor: 'rgba(40, 50, 35, 0.12)',
    dividerColor: 'rgba(40, 50, 35, 0.08)',

    fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
    fontFamilyMono: "'Fira Code', ui-monospace, monospace",

    borderRadius: '12px',
    borderRadiusSmall: '6px',

    errorColor: '#9c4538',
    warningColor: '#7a5f10',
    successColor: '#4d6349',
    infoColor: '#4d6349'
  },
  Button: {
    fontWeight: '500',
    colorPrimary: '#4d6349',
    colorHoverPrimary: '#405239',
    textColorPrimary: '#ffffff',
    borderRadiusMedium: '12px',
    borderRadiusSmall: '6px'
  },
  Card: {
    color: '#ffffff',
    borderColor: 'rgba(40, 50, 35, 0.12)',
    borderRadius: '12px'
  },
  Tag: {
    color: '#e6ece2',
    borderColor: 'rgba(110, 139, 106, 0.35)',
    textColor: '#3d4f3a',
    borderRadius: '6px'
  },
  Input: {
    color: '#ffffff',
    colorFocus: '#f6f4ee',
    border: '1px solid rgba(40, 50, 35, 0.6)',
    borderHover: '1px solid #4d6349',
    borderFocus: '1px solid #4d6349',
    borderRadius: '12px',
    textColor: '#2a3328',
    placeholderColor: 'rgba(42, 51, 40, 0.72)'
  }
}
